import styled from "styled-components";

export const SSettingsTopNavName = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;
